import CrudPage from "@/components/CrudPage";
import { useAuth } from "@/contexts/AuthContext";

export default function Suppliers() {
  const { user } = useAuth();
  const canWrite = ["Owner", "ProductionManager", "Bookkeeper"].includes(user?.role);
  return (
    <CrudPage
      eyebrow="Master data"
      title="Suppliers"
      description="Green coffee suppliers."
      testIdPrefix="suppliers"
      resource="suppliers"
      canWrite={canWrite}
      canEdit={canWrite}
      emptyHint="Add the suppliers you buy green coffee from."
      columns={[
        { key: "name", label: "Name" },
        { key: "contact_email", label: "Email" },
        { key: "contact_phone", label: "Phone" },
        { key: "address", label: "Address" },
        { key: "is_active", label: "Status",
          render: (it) => it.is_active === false
            ? <span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-muted text-muted-foreground font-bold">inactive</span>
            : <span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-[hsl(132,18%,36%)]/10 text-[hsl(132,18%,36%)] font-bold">active</span> },
      ]}
      fields={[
        { key: "name", label: "Name", required: true },
        { key: "contact_email", label: "Email" },
        { key: "contact_phone", label: "Phone" },
        { key: "address", label: "Address" },
        { key: "notes", label: "Notes", type: "textarea" },
        { key: "is_active", label: "Active", type: "boolean", default: true, placeholder: "Show this supplier in pickers and bills filter" },
      ]}
    />
  );
}
